<template>
  <div class="login d-flex">
    <div class="img">
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Placeholder_view_vector.svg/681px-Placeholder_view_vector.svg.png"
        alt=""
      />
    </div>
    <div class="customForm d-flex flex-column justify-center">
      <h1>Login</h1>
      <h3>Bienvenido a App de Tasaciones Igelmotor</h3>
      <v-form ref="form" v-model="valid" lazy-validation v-if="!spinn">
        <v-text-field
          v-model="email"
          :rules="emailRules"
          label="E-mail"
          required
        ></v-text-field>

        <v-text-field
          v-model="password"
          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rulesPass.required, rulesPass.min]"
          :type="show ? 'text' : 'password'"
          label="Contraseña"
          hint="Al menos 8 caracteres"
          counter
          @click:append="show = !show"
        ></v-text-field>

        <v-btn
          :disabled="!valid"
          color="success"
          class="mr-4"
          @click="validate"
        >
          LOGIN
        </v-btn>
      </v-form>
      <v-progress-circular
        v-if="spinn"
        :width="3"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      :color="snackbarColor"
    >
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";

const BASE_URL = process.env.VUE_APP_BASEURL;
import { mapMutations } from "vuex";

export default {
  data: () => ({
    spinn: false,
    snackbar: false,
    snackbarText: "",
    snackbarTimeout: 3000,
    snackbarColor: "",
    valid: true,
    email: "",
    emailRules: [
      v => !!v || "E-mail obligatorio",
      v => /.+@.+\..+/.test(v) || "E-mail debe ser válido"
    ],
    show: false,
    password: "",
    rulesPass: {
      required: value => !!value || "Campo obligatorio.",
      min: v => v.length >= 8 || "Minimo 8 caracteres"
    }
  }),

  methods: {
    ...mapMutations(["setUser"]),
    async validate() {
      this.spinn = true;
      const options = {
        method: "POST",
        url: BASE_URL + "/api/login",
        data: { email: this.email, password: this.password }
      };

      try {
        const response = await axios.request(options);
        if (response.status == 200) {
          this.setUser(response.data.payload);
          this.spinn = false;
          this.$router.push("/");
        } else {
          this.snackbar = true;
          this.snackbarText = response.data.message;
          this.snackbarColor = "red";
          this.spinn = false;
        }
      } catch (error) {
        console.log(error);
        this.snackbar = true;
        this.snackbarText = error.response.data.message;
        this.snackbarColor = "red";
        this.spinn = false;
      }
      this.spinn = false;
    }
  }
};
</script>

<style scoped>
.login {
  height: 99vh;
}
.img {
  height: 100%;
  width: 50%;
}
.img img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.customForm {
  flex-grow: 1;
  padding: 50px;
}

@media only screen and (max-width: 600px) {
  .img {
    display: none;
  }
}
</style>
